import { render, staticRenderFns } from "./RegistUser.vue?vue&type=template&id=ef07c69c&scoped=true&"
import script from "./RegistUser.vue?vue&type=script&lang=js&"
export * from "./RegistUser.vue?vue&type=script&lang=js&"
import style0 from "./RegistUser.vue?vue&type=style&index=0&id=ef07c69c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef07c69c",
  null
  
)

export default component.exports